(function(){
  var root = document.querySelector('.nmt');
  if(!root) return;

  /* ---------- video lite embed ---------- */
  var yt = root.querySelector('#nmt-yt');
  if(yt){
    yt.addEventListener('click', function(){
      var f = document.createElement('iframe');
      f.className = 'ytframe';
      f.src = 'https://www.youtube-nocookie.com/embed/Xf41ZsG7IY8?autoplay=1&rel=0';
      f.title = 'Anatomía de una tornamesa';
      f.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture';
      f.allowFullscreen = true;
      yt.parentNode.replaceChild(f, yt);
    });
  }

  /* ---------- tabs motor ---------- */
  var tabs = root.querySelectorAll('.tabs button');
  Array.prototype.forEach.call(tabs, function(t){
    t.addEventListener('click', function(){
      Array.prototype.forEach.call(tabs, function(o){
        o.setAttribute('aria-selected', o === t ? 'true' : 'false');
        var p = root.querySelector('#' + o.getAttribute('aria-controls'));
        if(p){ p.classList.toggle('on', o === t); p.hidden = (o !== t); }
      });
    });
  });

  /* ---------- disponibilidad en vivo ----------
     Cada enlace a producto se consulta contra /products/<handle>.js (API Ajax de Shopify).
     Si el producto no esta disponible, el enlace queda marcado "sin stock" y al lado
     aparece "Preguntar por disponibilidad" hacia el WhatsApp de SAC, con el nombre del
     producto ya escrito en el mensaje. Se consulta al entrar en pantalla, no todo de golpe.
     Si la consulta falla (por ejemplo abriendo el archivo local) no se toca nada. */
  var WSP = 'https://api.whatsapp.com/send?phone=56933943028&text=';
  var stockCache = {};

  function handleDe(a){
    var m = (a.getAttribute('href') || '').match(/^\/products\/([a-z0-9\-]+)/);
    return m ? m[1] : null;
  }

  function datosDe(h){
    if(!(h in stockCache)){
      stockCache[h] = fetch('/products/' + h + '.js', { headers:{ 'Accept':'application/json' } })
        .then(function(r){ return r.ok ? r.json() : null; })
        .catch(function(){ return null; });
    }
    return stockCache[h];
  }

  function marcarAgotado(a, titulo){
    if(a.getAttribute('data-agotado')) return;
    a.setAttribute('data-agotado', '1');
    a.classList.add('agotado');
    var tag = document.createElement('span');
    tag.className = 'sinstock';
    tag.textContent = 'sin stock';
    var preg = document.createElement('a');
    preg.className = 'preguntar';
    preg.href = WSP + encodeURIComponent('Hola, quiero saber si tienen disponible: ' + (titulo || a.textContent.trim()));
    preg.target = '_blank';
    preg.rel = 'noopener';
    preg.textContent = 'Preguntar por disponibilidad';
    a.insertAdjacentElement('afterend', preg);
    a.insertAdjacentElement('afterend', tag);
  }

  function revisarStock(a){
    var h = handleDe(a); if(!h) return;
    datosDe(h).then(function(d){ if(d && d.available === false) marcarAgotado(a, d.title); });
  }

  var obs = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ obs.unobserve(e.target); revisarStock(e.target); } });
  }, { rootMargin:'200px' }) : null;

  function escanearStock(scope){
    (scope || root).querySelectorAll('a[href^="/products/"]').forEach(function(a){
      if(a.getAttribute('data-visto')) return;
      a.setAttribute('data-visto', '1');
      if(obs) obs.observe(a); else revisarStock(a);
    });
  }

  /* ---------- anatomia ---------- */
  var YT = 'https://www.youtube.com/watch?v=Xf41ZsG7IY8&t=';
  var PARTS = {
    plato:{ n:'01', t:'El plato', ts:478, tsl:'7:58',
      d:'La plataforma que gira. Acá solo se ve su borde de aluminio, porque el resto queda tapado por la alfombrilla. Los hay de vidrio, de aluminio y de resina, y lo que realmente importa es que su masa esté repartida de forma pareja: si no lo está, al girar genera fuerzas que el motor tiene que corregir y eso llega hasta la aguja.',
      links:[] },
    slipmat:{ n:'02', t:'El slipmat', ts:503, tsl:'8:23',
      d:'La alfombrilla entre el plato y el vinilo. Evita que el vinilo quede apoyado sobre una superficie dura y ayuda a que quede bien fijo. Los hay de goma, de caucho, de fieltro y de papel, y cada material cambia un poco el carácter del sonido.',
      links:[['Estabilizador AT618a','/products/estabilizador-at618a-600gr']] },
    eje:{ n:'03', t:'El eje de rotación', ts:653, tsl:'10:53',
      d:'El pilar del centro donde calza el vinilo. Parece lo más simple del aparato y en cierto modo lo es, pero es el punto donde el motor entrega el giro y donde el vinilo queda centrado. Si algo está descentrado acá, se escucha.',
      links:[] },
    plinto:{ n:'04', t:'El plinto', ts:434, tsl:'7:14',
      d:'La base. Contiene el motor y toda la tecnología, y sobre todo aísla de las vibraciones externas, que en un medio analógico se traducen derechamente en sonido. Se puede resolver con mucha masa, o como hace Rega, con plintos delgados de materiales muy densos.',
      links:[['Patas aislantes Nagaoka','/products/clon-de-patas-aislantes-para-tornamesas-ins-su02'],['Nivelador de burbuja','/products/nivelador-burbuja-audio-technica-at615a']] },
    brazo:{ n:'05', t:'El brazo fonocaptor', ts:209, tsl:'3:29',
      d:'Sostiene la cápsula y la lleva por el surco. Se construyen en carbono, aluminio o acero, y los hay rectos o en forma de S o J. Su largo y su masa deciden cómo ataca la aguja el surco y cuánta distorsión se cuela. Es una de las tres piezas que más mandan sobre el resultado.',
      links:[['Todas las tornamesas','/collections/tornamesas']] },
    capsula:{ n:'06', t:'La cápsula, la aguja y el portacápsulas', ts:337, tsl:'5:37',
      d:'La cápsula es el micrófono de la tornamesa: convierte el roce de la aguja con el surco en señal eléctrica. Es la pieza más sensible de todas y la que más transforma el sonido. La aguja va montada sobre un puentecito llamado cantilever, y todo eso se atornilla al portacápsulas. En esta tornamesa el portacápsulas sale entero, que es justo lo que quieres si te da por probar cápsulas distintas; uno fijo, en cambio, conserva algo mejor la señal porque tiene menos piezas intermedias.',
      links:[['Encuentra tu aguja (selector)','/pages/encuentra-tu-aguja'],['Cápsula AT-VM95E','/products/capsula-audio-technica-at-vm95e'],['Cápsula AT-VM95E con portacápsulas','/products/capsula-vm95-montada-en-cabezal-at-hs6'],['Todas las cápsulas y agujas','/collections/capsulas-y-agujas']] },
    contrapeso:{ n:'07', t:'El contrapeso', ts:254, tsl:'4:14',
      d:'Va en la cola del brazo y regula con cuánta fuerza se apoya la aguja sobre el vinilo. Cada cápsula trae su peso recomendado por el fabricante. Si va muy pesado, desgastas la aguja y el vinilo; si va muy liviano, la aguja salta y distorsiona.',
      links:[['Contrapeso RP1 (Planar 1)','/products/contrapeso-rp1-planar-1-matt-rb110']] },
    antiskating:{ n:'08', t:'El antiskating', ts:276, tsl:'4:36',
      d:'El brazo tiene una tendencia natural a irse hacia el centro. Si esa fuerza es mucha, la aguja se apoya contra una sola pared del surco y aparece distorsión en un canal. Este dial la compensa. Se ajusta al mismo valor que la fuerza vertical y se olvida.',
      links:[] },
    elevador:{ n:'09', t:'El elevador y el descanso', ts:291, tsl:'4:51',
      d:'La palanquita mantiene el brazo suspendido para que la aguja nunca caiga de golpe: la posas donde quieres y recién ahí la bajas. Cuando terminas, el brazo vuelve a su descanso, que trae un seguro para mover la tornamesa sin dañar nada.',
      links:[] },
    velocidad:{ n:'10', t:'Las velocidades: 33 y 45', ts:514, tsl:'8:34',
      d:'Los dos estándares de giro, en revoluciones por minuto. Los vinilos de 12 pulgadas casi siempre van a 33 y los singles chicos a 45. Si un vinilo suena raro, más lento o más agudo de lo que recuerdas, este es el primer botón que hay que mirar.',
      links:[] },
    pitch:{ n:'11', t:'El pitch y el estroboscopio', ts:533, tsl:'8:53',
      d:'Este deslizante acelera o frena el giro un cierto porcentaje, y solo lo traen las tornamesas pensadas para mezclar: sirve para calzar el tempo de un vinilo con el de otro. Trabaja junto a los puntitos impresos en el borde del plato: una luz roja los ilumina y, si los ves quietos, vas exactamente a la velocidad original. Si empiezan a correrse hacia un lado, estás acelerando o frenando.',
      links:[['Tornamesa AT-LP120XUSB','/products/tornamesa-audio-technica-at-lp120x-usb'],['Tornamesa AT-LP140XP','/products/tornamesa-audio-technica-at-lp140xp']] },
    salida:{ n:'12', t:'La salida de audio', ts:620, tsl:'10:20', rear:true,
      d:'Casi siempre RCA, y va en el panel trasero. Por eso al tocar esta pieza cambiamos la foto: esto es la parte de atrás de la misma tornamesa. Por ahí sale la señal hacia el pre phono o el amplificador, porque lo que entrega la cápsula es demasiado débil para mover un parlante por sí solo. Es el punto donde tu tornamesa deja de estar sola y empieza a ser un sistema.',
      legend:[['PHONO / LINE','El interruptor que enciende o apaga el pre phono que la tornamesa trae adentro. En LINE sale la señal ya corregida y la conectas directo a parlantes activos. En PHONO sale cruda y necesitas un pre aparte.'],
              ['R y L','El par de conectores RCA, rojo y blanco. Son los que van al amplificador o a los parlantes.'],
              ['GND','El tornillo de tierra. Si escuchas un zumbido de fondo constante, casi siempre es por este cable suelto.'],
              ['USB','Para digitalizar tus vinilos en el computador. No lo necesitas para escuchar.'],
              ['DC IN','La corriente. Antes de enchufar, revisa que el voltaje sea el de tu país.']],
      links:[['Pre phono Fosi ZP3','/products/preamplificador-zp3-fosi-audio'],['Rega Fono Mini A2D','/products/equipo-rega-pre-amplificador-fono-mini-a2d'],['Amplificadores y pre phono','/collections/amplificadores-pre-phono']] }
  };
  var ORDER = ['plato','slipmat','eje','plinto','brazo','capsula','contrapeso','antiskating','elevador','velocidad','pitch','salida'];
  var panel = root.querySelector('#nmt-panel');
  var listEl = root.querySelector('#nmt-partlist');
  var figEl = root.querySelector('.anatimg');
  var hots = root.querySelectorAll('.hot');

  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;'); }

  var actual = 'plato', previa = 'plato';

  function render(key){
    var p = PARTS[key]; if(!p) return;
    if(key !== actual){ previa = actual; actual = key; }
    var html = '<span class="num">' + p.n + '</span><h3>' + esc(p.t) + '</h3><p>' + esc(p.d) + '</p>' +
      '<a class="tstamp" href="' + YT + p.ts + 's" target="_blank" rel="noopener">Ver en el video &middot; ' + p.tsl + '</a>';
    if(p.legend){
      html += '<div class="conex"><p class="lbl">Qué es cada conector</p><dl>';
      p.legend.forEach(function(l){ html += '<dt>' + esc(l[0]) + '</dt><dd>' + esc(l[1]) + '</dd>'; });
      html += '</dl></div>';
    }
    if(p.links.length){
      html += '<ul class="plinks"><li class="lbl">Lo que puedes cambiar o sumar</li>';
      p.links.forEach(function(l){ html += '<li><a href="' + l[1] + '">' + esc(l[0]) + '</a></li>'; });
      html += '</ul>';
    }
    panel.innerHTML = html;
    escanearStock(panel);
    if(figEl) figEl.classList.toggle('rearon', !!p.rear);
    Array.prototype.forEach.call(hots, function(h){ h.classList.toggle('on', h.getAttribute('data-part') === key); });
    Array.prototype.forEach.call(listEl.querySelectorAll('button'), function(b){
      b.setAttribute('aria-pressed', b.getAttribute('data-part') === key ? 'true' : 'false');
    });
  }

  ORDER.forEach(function(k){
    var li = document.createElement('li');
    var b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('data-part', k);
    b.setAttribute('aria-pressed', k === 'plato' ? 'true' : 'false');
    b.textContent = PARTS[k].n + ' ' + PARTS[k].t;
    b.addEventListener('click', function(){ render(k); });
    li.appendChild(b); listEl.appendChild(li);
  });

  Array.prototype.forEach.call(hots, function(h){
    var k = h.getAttribute('data-part');
    h.addEventListener('click', function(){ render(k); });
    h.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); render(k); }
    });
  });

  var btnVolver = root.querySelector('#nmt-volver');
  if(btnVolver){
    btnVolver.addEventListener('click', function(){
      render(previa === 'salida' ? 'plato' : previa);
    });
  }

  render('plato');
  escanearStock();

  /* ---------- filtro tornamesas ---------- */
  var chips = root.querySelectorAll('#nmt-chips button');
  var cards = root.querySelectorAll('#nmt-tornas .torna');
  var empty = root.querySelector('#nmt-empty');
  Array.prototype.forEach.call(chips, function(c){
    c.addEventListener('click', function(){
      var f = c.getAttribute('data-filter');
      Array.prototype.forEach.call(chips, function(o){ o.setAttribute('aria-pressed', o === c ? 'true' : 'false'); });
      var shown = 0;
      Array.prototype.forEach.call(cards, function(card){
        var tags = (card.getAttribute('data-tags') || '').split(' ');
        var ok = (f === 'todas') || tags.indexOf(f) !== -1;
        card.hidden = !ok;
        if(ok) shown++;
      });
      if(empty) empty.hidden = shown > 0;
    });
  });
})();
